import { Component, AfterViewInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { QuantityFactorGridDTO } from '../models/administration-models';
import { AdministrationService } from '../services/administration.service';

@Component({
  selector: 'app-qfg-table-dialog',
  templateUrl: './qfg-table-dialog.component.html',
  styleUrls: ['./qfg-table-dialog.component.scss'],
  providers: [AdministrationService]
})
export class QfgTableDialogComponent implements AfterViewInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<QuantityFactorGridDTO>([]);
  dataColumns: String[] = ['id', 'categoryId', 'categoryName', 'minQty', 'maxQty', 'active'];
  displayedColumns = this.dataColumns;

  constructor(private adminService: AdministrationService,
              public dialogRef: MatDialogRef<QfgTableDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: QuantityFactorGridDTO
  ) { }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.adminService.getQuantityFactorGrid().subscribe((response: any) => { 
      this.dataSource.data = response
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  close(): void {
    this.dialogRef.close();
  }

}
